var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "editorProtocol"
  }, [_vm.treeMode != 'readonly' && !_vm.newProtocolViewBln ? _c('Options', {
    attrs: {
      "diagram": _vm.diagram
    }
  }, [_c('div', {
    staticClass: "diagramAddOn"
  }, [_c('div', {
    staticClass: "overviewWrap"
  }, [_c('button', {
    staticClass: "mapOpen",
    on: {
      "click": function ($event) {
        _vm.overviewStatus = !_vm.overviewStatus;
      }
    }
  }, [_vm._v("Map")])]), _c('div', {
    staticClass: "overview_wrap"
  }, [_c('div', {
    staticClass: "overview",
    class: {
      on: _vm.overviewStatus
    }
  }, [_c('div', {
    staticClass: "title_area"
  }, [_c('strong', {
    staticClass: "tit"
  }, [_vm._v("Map")])]), _c('div', {
    staticClass: "editor_overview",
    attrs: {
      "id": "editor-overview"
    }
  })])]), _c('div', {
    staticClass: "editorBtmWrap"
  }, [_vm.treeMode == 'templete' && !_vm.initChecked ? _c('button', {
    staticClass: "mode",
    on: {
      "click": function ($event) {
        return _vm.modeChange('normal');
      }
    }
  }, [_vm._v("일반 모드로 이동")]) : _vm._e(), _vm.treeMode == 'normal' ? _c('button', {
    staticClass: "mode normal",
    on: {
      "click": function ($event) {
        return _vm.modeChange('templete');
      }
    }
  }, [_vm._v("템플릿 수정 모드로 이동")]) : _vm._e()])])]) : _vm._e(), _vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('TreeNodeOption', {
    attrs: {
      "diagram": _vm.diagram,
      "treeMode": _vm.treeMode,
      "optionList": _vm.optionList,
      "selectedIssue": _vm.selectedIssue,
      "selectedNodes": _vm.selectedNodes,
      "tagTempleteData": _vm.tagTempleteData,
      "optionColors": _vm.optionColors
    },
    on: {
      "change": _vm.rendModel
    }
  }) : _vm._e(), _c('div', {
    staticClass: "canvas",
    attrs: {
      "id": "editor-protocol"
    }
  }), _c('contextMenuTemplate', {
    attrs: {
      "crntObj": _vm.crntObj,
      "memoObj": _vm.memoObj,
      "treeMode": _vm.treeMode,
      "renameNodeObj": _vm.renameNodeObj,
      "addChildNodeObj": _vm.addChildNodeObj,
      "addSiblingNodeObj": _vm.addSiblingNodeObj
    },
    on: {
      "contextMounted": _vm.getContext
    }
  }), _c('Popup', {
    attrs: {
      "crntObj": _vm.crntObj
    }
  }, [_c('child-node', {
    attrs: {
      "slot": `child`,
      "crntObj": _vm.crntObj
    },
    slot: `child`
  }), _c('sibling-node', {
    attrs: {
      "slot": `sibling`,
      "crntObj": _vm.crntObj
    },
    slot: `sibling`
  }), _c('re-name-node', {
    attrs: {
      "slot": `rename`,
      "crntObj": _vm.crntObj
    },
    slot: `rename`
  })], 1), _c('memo-node', {
    attrs: {
      "memoObj": _vm.memoObj
    }
  }), _vm.newProtocolViewBln ? _c('new-protocol', {
    on: {
      "click": function ($event) {
        _vm.makeProtocolModal = true;
      }
    }
  }) : _vm._e(), _c('ProcessSearch', {
    attrs: {
      "type": _vm.processSearchMode,
      "searchLinkData": _vm.searchLinkData,
      "overWriteProtocolMode": _vm.overWriteProtocolMode
    },
    on: {
      "select-protocol": function ($event) {
        return _vm.selectProtocol($event);
      },
      "setMethod": function ($event) {
        return _vm.getChildMethods($event);
      }
    }
  }), !_vm.newProtocolViewBln && _vm.treeMode != 'readonly' ? _c('div', {
    staticClass: "undoRedoWrap"
  }, [_c('button', {
    staticClass: "undo",
    class: _vm.undoClass,
    on: {
      "click": _vm.undoHandler
    }
  }, [_vm._v("undo")]), _c('button', {
    staticClass: "redo",
    class: _vm.redoClass,
    on: {
      "click": _vm.redoHandler
    }
  }, [_vm._v("redo")])]) : _vm._e(), _c('MakeProcess', {
    attrs: {
      "Type": "protocol|make",
      "active": _vm.makeProtocolModal
    },
    on: {
      "confirm": _vm.addNewProtocolHandler,
      "close": function ($event) {
        _vm.makeProtocolModal = false;
      }
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.editStatusAlert,
      expression: "editStatusAlert"
    }],
    staticClass: "modalPopupLayout active"
  }, [_c('div', {
    staticClass: "contentWrap"
  }, [_c('h2', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.editStatusTitle))]), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center",
      "width": "300px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.editStatusContent)
    }
  })]), _c('div', {
    staticClass: "ctrl",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "sm_btn color_2",
    on: {
      "click": function ($event) {
        return _vm.$router.go(_vm.$router.currentRoute);
      }
    }
  }, [_vm._v("확인")])])])]), _c('dictionaryPopup', {
    attrs: {
      "crntObj": _vm.dictionaryPopup
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }